import React, { memo, useEffect, useState } from 'react';
import { FontResponse } from '@business/entities/google';

// Google Fonts CSS API needs spaces in family names as "+" (a literal/%20-encoded space is rejected),
// and variant tokens like "regular"/"700italic" must be the CSS form ("400"/"700i"). The old code sent
// "Open Sans:regular|..." which failed for any multi-word font, so those fonts never loaded.
const variantToToken = (v: string) => (v === 'regular' ? '400' : v === 'italic' ? '400i' : v.replace('italic', 'i'));

const createLink = (font: FontResponse) => {
  const family = (font.family || '').trim().replace(/ /g, '+');
  const variants = (font.variants && font.variants.length ? font.variants : ['regular']).map(variantToToken);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css?family=${family}:${variants.join(',')}&display=swap`;

  return link;
};

export interface GoogleFontLoaderProps {
  font: FontResponse;
}

export const GoogleFontLoader = memo((props: GoogleFontLoaderProps) => {
  const { font } = props;
  const [link, setLink] = useState(createLink(font));

  useEffect(() => {
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [link]);

  useEffect(() => {
    setLink(createLink(font));
  }, [font]);

  return null;
});
